<template>
  <div class="fund-saving-plan-illustration">
    <img
      :class="{'-show': isInfrastructure && riskValue >= 3}"
      class="infra infra-3"
      src="../../images/fund-saving-plan/infra-3.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isConsumption && riskValue >= 2}"
      class="image citizen-2"
      src="../../images/fund-saving-plan/citizen-2.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isConsumption && riskValue >= 3}"
      class="image citizen-3"
      src="../../images/fund-saving-plan/citizen-3.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isConsumption && riskValue >= 4}"
      class="image citizen-4"
      src="../../images/fund-saving-plan/citizen-4.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isConsumption && riskValue >= 5}"
      class="image citizen-5"
      src="../../images/fund-saving-plan/citizen-5.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isIndustry && riskValue >= 2}"
      class="image industry-2"
      src="../../images/fund-saving-plan/industry-2.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isIndustry && riskValue >= 3}"
      class="image industry-3"
      src="../../images/fund-saving-plan/industry-3.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': riskValue >= 4}"
      class="image base-4"
      src="../../images/fund-saving-plan/base-4.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isIndustry && riskValue >= 4}"
      class="image industry-4"
      src="../../images/fund-saving-plan/industry-4.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isIndustry && riskValue >= 5}"
      class="image industry-5"
      src="../../images/fund-saving-plan/industry-5.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isInfrastructure && riskValue >= 2}"
      class="image infra-2"
      alt="Illustration-Background"
      src="../../images/fund-saving-plan/infra-2.svg"
    >
    <img
      :class="{'-show': isInfrastructure && riskValue >= 4}"
      class="image infra-4"
      src="../../images/fund-saving-plan/infra-4.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': isInfrastructure && riskValue >= 5}"
      class="image infra-5"
      src="../../images/fund-saving-plan/infra-5.svg"
      alt="Illustration-Background"
    >

    <img
      class="base base-1"
      src="../../images/fund-saving-plan/base-1.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': riskValue >= 2}"
      class="image base-2"
      src="../../images/fund-saving-plan/base-2.svg"
      alt="Illustration-Background"
    >
    <img
      :class="{'-show': riskValue >= 3}"
      class="image base-3"
      src="../../images/fund-saving-plan/base-3.svg"
      alt="Illustration-Background"
    >

    <img
      :class="{'-show': riskValue >= 5}"
      class="image base-5"
      src="../../images/fund-saving-plan/base-5.svg"
      alt="Illustration-Background"
    >
    <img
      class="background"
      src="../../images/fund-saving-plan/background.svg"
      alt="Illustration-Background"
    >
  </div>
</template>

<script>
export default {
  name: 'FundSavingPlanIllustration',
  components: {},
  props: {
    isConsumption: {
      type: Boolean,
      default: false,
    },
    isIndustry: {
      type: Boolean,
      default: false,
    },
    isInfrastructure: {
      type: Boolean,
      default: false,
    },
    riskValue: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style>
</style>
